import axios from 'axios'
import { actions as AuthActions } from '../store/slices/AuthSlice'
import { setupNewExpirationCheck } from './expirationUtils'

export const setupExpiredSessionInterceptor = (dispatch, getState) => {
    axios.interceptors.response.use(
        response => {
            setupNewExpirationCheck(dispatch, getState)
            return response
        },
        error => {
            const {
                status,
                config: { url = '' },
                data: { message = '' },
            } = error?.response || {}

            if (
                status === 401 &&
                (message.substring(0, 15) === 'Session expired' ||
                    url !== '/ajax/login')
            ) {
                dispatch(AuthActions.hasExpired())
            } else {
                setupNewExpirationCheck(dispatch, getState)
            }

            return Promise.reject(error)
        },
    )
}
